import * as _ from 'lodash';

export function simplifyName(name: string): string {
    return _.replace(deburrAndLower(name), /[\W_]+/g, '');
}

export function deburrAndLower(text: string): string {
    return _.deburr(_.toLower(text));
}
